var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "client-user-wrap" },
    [
      _c(
        "el-row",
        { staticClass: "content-wrap" },
        [
          _c("el-col", { staticClass: "side-left", attrs: { span: 6 } }, [
            _c(
              "div",
              { staticClass: "__left-inner" },
              [_c("AsideLeft", { attrs: { siteIds: _vm.siteIds } })],
              1
            ),
          ]),
          _c("el-col", { staticClass: "content-right", attrs: { span: 18 } }, [
            _c("div", { staticClass: "__right-inner" }, [
              _c(
                "div",
                { staticClass: "top-box" },
                [_c("client-user-header")],
                1
              ),
              _c(
                "div",
                { staticClass: "scroll-box" },
                [
                  _c("div", { staticClass: "mid-box" }, [_c("mid-policy")], 1),
                  _c(
                    "el-row",
                    { staticClass: "bottom-box" },
                    [
                      _c(
                        "el-col",
                        { staticClass: "__kee", attrs: { span: 8 } },
                        [_c("kee")],
                        1
                      ),
                      _c(
                        "el-col",
                        { staticClass: "__tools", attrs: { span: 16 } },
                        [
                          _c(
                            "div",
                            { staticClass: "__inner" },
                            [_c("tech-transformation")],
                            1
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
      _c("v-bottom"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }